import React from 'react';
import cn from 'classnames';
export default function FaviconColor(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    style = _ref.style,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("span", {
    role: "img",
    className: cn('icons', className),
    style: style
  }, /*#__PURE__*/React.createElement("svg", {
    width: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70506 1.14324L23.3649 10.7691C23.5609 10.907 23.721 11.0911 23.8316 11.3056C23.9422 11.52 24 11.7585 24 12.0005C24 12.2426 23.9422 12.4811 23.8316 12.6955C23.721 12.91 23.5609 13.0941 23.3649 13.232L9.70506 22.8587C9.48349 23.015 9.22395 23.1068 8.95462 23.1239C8.68529 23.1411 8.41647 23.0831 8.17736 22.9561C7.93825 22.8291 7.73799 22.6381 7.59835 22.4037C7.4587 22.1694 7.385 21.9006 7.38525 21.6268V2.37433C7.38515 2.10051 7.45895 1.8319 7.59865 1.59766C7.73836 1.36342 7.93862 1.17249 8.17771 1.04561C8.41679 0.918735 8.68555 0.860753 8.95481 0.877964C9.22408 0.895174 9.48355 0.986919 9.70506 1.14324Z",
    fill: "#00A5EB"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: 'multiply'
    }
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3143 2.62199L13.9857 10.7659C14.1833 10.9036 14.3449 11.088 14.4566 11.3033C14.5682 11.5185 14.6266 11.7581 14.6266 12.0014C14.6266 12.2446 14.5682 12.4842 14.4566 12.6995C14.3449 12.9147 14.1833 13.0991 13.9857 13.2368L2.3143 21.3799C2.09255 21.5349 1.83328 21.6254 1.56452 21.6416C1.29575 21.6579 1.02773 21.5992 0.789431 21.4721C0.551132 21.3449 0.351625 21.154 0.212485 20.9201C0.0733459 20.6862 -0.000130924 20.4181 7.72183e-07 20.1448V3.85787C-0.000274584 3.58456 0.0730979 3.31637 0.21218 3.08233C0.351262 2.84829 0.550757 2.6573 0.789082 2.53003C1.02741 2.40276 1.29549 2.34405 1.56432 2.36026C1.83315 2.37647 2.0925 2.46697 2.3143 2.62199Z",
    fill: "#00CA9F"
  }))));
}